export const defaultGeneralPostChatSurveyPaneStyleProps = {
  position: "initial",
  height: "100%",
  width: "100%",
  left: "0%",
  top: "0%",
  borderRadius: "0 0 4px 4px",
  borderWidth: "0px"
};